import React from "react";
import "./SampleDL.scss";
import DLFront from "../../../assets/docSampleImages/DL FRONT.jpg";
import DLBACK from "../../../assets/docSampleImages/DL BACK.jpg";
import GuideModal from "../../UI/GuideModal/GuideModal";
export interface IViewSampleDLPopup {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?: string;
}
const SampleDrivingLicensePopup = (props: IViewSampleDLPopup) => {
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };

  return (
    <GuideModal
      open={!!props.showPopup}
      onClose={closePopup}
      title="Uploading Driving Licence"
      titleId="sample-dl-popup-title"
    >

        {/* Popup Content */}
        {/* {commonUIView()} */}

        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Driving Licence in
              JPEG or PNG (Max Size: 2MB)
            </p>
            <span className="Aadhar-Front-row">
              <div className="image-container">
                <img
                  src={DLFront}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image" alt="Sample driving license front" />
                <div className="badge">1</div>
              </div>

              <span className="Aadhar-Label">FRONT</span>
            </span>
            <span className="Aadhar-Front-row mt-20">
              <div className="image-container">
                <img
                  src={DLBACK}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image" alt="Sample driving license back" />
                <div className="badge">2</div>
              </div>

              <span className="Aadhar-Label">BACK</span>
            </span>
          </span>
        </div>
    </GuideModal>
  );
};
export default SampleDrivingLicensePopup;
